import styled from 'styled-components';

const Logo = styled.div`
  max-height: 70px;
  max-width: 450px;
  margin-right: auto;
  display: flex;
  align-items: center;
  a {
    display: flex;
    justify-content: center;
  }
  @media screen and (max-width: 375px) {
    img {
      max-height: 50px;
    }
  }
`;

export default {
  Logo,
};
